const ASSET_ID = 21364625;
export { ASSET_ID };
